export const fr = {
  code: 'fr',
  wordmark: { main: 'DELUXE', sub: 'ENTREPRISE', reversed: true },
  nav: {
    home: 'Accueil',
    services: 'Services',
    about: 'À propos',
    seasonal: 'Saisonnier',
    contact: 'Contact',
    getQuote: 'OBTENIR UNE SOUMISSION',
    openMenu: 'Ouvrir le menu',
    closeMenu: 'Fermer le menu',
  },
  hero: {
    eyebrow: "SERVICES D'ENTRETIEN RÉSIDENTIEL",
    line1: 'VOTRE PROPRIÉTÉ.',
    line2: 'SIGNÉE DELUXE.',
    sub: "Services professionnels d'aménagement paysager, d'entretien de pelouse et d'entretien saisonnier pour les propriétaires de Montréal, Laval, de la Rive-Nord et des Laurentides.",
    ctaPrimary: 'OBTENIR UNE SOUMISSION GRATUITE',
    ctaSecondary: 'DÉCOUVRIR LES SERVICES',
    strip: 'Entretien de pelouse • Aménagement paysager • Entretien saisonnier',
    alt: 'Maison québécoise moderne avec pelouse fraîchement entretenue au crépuscule',
    scroll: 'Défiler',
  },
  values: {
    items: [
      { title: 'PROFESSIONNEL', text: 'Un travail soigné, axé sur les détails.' },
      { title: 'PRATIQUE', text: 'Remettez les travaux de la propriété sur notre liste, pas la vôtre.' },
      { title: 'SAISONNIER', text: 'Des services adaptés aux besoins changeants de votre propriété.' },
      { title: 'LOCAL', text: 'Au service des propriétaires de Montréal, Laval, de la Rive-Nord et des Laurentides.' },
    ],
  },
  marquee: ['ENTRETIEN DE PELOUSE', 'AMÉNAGEMENT PAYSAGER', 'NETTOYAGE DE GOUTTIÈRES', 'LAVAGE DE VITRES', 'NETTOYAGE DE BACS', 'ENTRETIEN SAISONNIER', 'VOTRE PROPRIÉTÉ. SIGNÉE DELUXE.'],
  services: {
    eyebrow: 'SERVICES',
    heading: 'LES TRAVAUX DONT VOTRE PROPRIÉTÉ A BESOIN.',
    sub: "De l'entretien régulier de la pelouse aux travaux saisonniers que les propriétaires préfèrent laisser à quelqu'un d'autre, DELUXE s'en occupe.",
    learnMore: 'EN SAVOIR PLUS',
    includes: 'Ce que le service peut inclure',
    scopeNote: 'Chaque propriété est différente — la portée exacte est confirmée avec votre soumission.',
    requestQuote: 'DEMANDER UNE SOUMISSION',
    beforeAfter: { before: 'AVANT', after: 'APRÈS', hint: 'Glissez pour comparer' },
    dual: ['TAILLÉES', 'EMBALLÉES POUR L’HIVER'],
    pageSub: 'Six services pratiques pour les propriétaires, livrés selon le même standard : un travail soigné, une communication claire et une propriété qui paraît bien entretenue.',
    items: [
      {
        id: 'lawn-care',
        short: 'Entretien de la pelouse',
        name: 'ENTRETIEN DE LA PELOUSE',
        desc: 'Gardez une pelouse propre, saine et bien entretenue tout au long de la saison.',
        includes: ['Tonte de la pelouse', 'Coupe et finition', 'Bordures précises', 'Entretien général de la pelouse'],
        img: 'lawn',
        alt: 'Une pelouse résidentielle avant (envahie) et après (fraîchement tondue, bandes nettes) — glissez pour comparer',
      },
      {
        id: 'landscaping-yard-maintenance',
        short: 'Aménagement paysager et entretien de cour',
        name: 'AMÉNAGEMENT PAYSAGER ET ENTRETIEN DE COUR',
        desc: 'Pour que le reste de votre espace extérieur soit aussi soigné que votre pelouse.',
        includes: ['Entretien général de la cour', 'Nettoyage extérieur', "Entretien de l'aménagement paysager", 'Retouches de la propriété'],
        img: 'landscaping',
        alt: 'Sentier de jardin aménagé dans une cour résidentielle bien entretenue',
      },
      {
        id: 'gutter-cleaning',
        short: 'Nettoyage de gouttières',
        name: 'NETTOYAGE DE GOUTTIÈRES',
        desc: 'Éliminez les accumulations saisonnières et gardez vos gouttières bien dégagées.',
        includes: ['Nettoyage saisonnier des gouttières', 'Enlèvement des débris', 'Vérification des descentes pluviales'],
        img: 'gutter',
        alt: 'Une gouttière avant (remplie de feuilles) et après (bien dégagée), vue du toit — glissez pour comparer',
      },
      {
        id: 'window-cleaning',
        short: 'Lavage de vitres',
        name: 'LAVAGE DE VITRES',
        desc: "Un extérieur impeccable commence par les détails que l'on remarque chaque jour.",
        includes: ['Lavage des vitres extérieures', 'Travail minutieux', 'Nettoyages saisonniers'],
        img: 'window',
        alt: 'Grandes fenêtres modernes avant (saliures et poussière) et après (nettoyage professionnel) — glissez pour comparer',
      },
      {
        id: 'bin-cleaning',
        short: 'Nettoyage de bacs à ordures',
        name: 'NETTOYAGE DE BACS À ORDURES',
        desc: "Un service simple pour l'une des corvées dont personne ne veut s'occuper.",
        includes: ['Lavage des bacs', 'Désodorisation', 'Nettoyages saisonniers'],
        img: 'bins',
        alt: 'Les mêmes bacs à ordures avant (sales) et après (nettoyés professionnellement) — glissez pour comparer',
      },
      {
        id: 'seasonal-care',
        short: 'Entretien saisonnier de la propriété',
        name: 'ENTRETIEN SAISONNIER DE LA PROPRIÉTÉ',
        desc: 'Quand les saisons changent, les besoins de votre propriété changent aussi.',
        includes: ['Nettoyage de printemps', "Nettoyage d'automne", 'Préparation saisonnière'],
        img: 'seasonal',
        alt: 'Haies de cèdres fraîchement taillées le long d’une cour résidentielle',
        altWinter: 'Les mêmes haies emballées de jute pour l’hiver québécois',
      },
    ],
  },
  yardSeasonal: {
    eyebrow: "OUVERTURE ET FERMETURE DE TERRAIN",
    heading: "NOUS L'OUVRONS. NOUS LE FERMONS.",
    intro: "Deux services complémentaires qui encadrent votre saison extérieure : DELUXE prépare votre terrain à l'arrivée du printemps et le ferme soigneusement avant l'hiver.",
    springTag: 'PRINTEMPS / ÉTÉ',
    fallTag: 'AUTOMNE / HIVER',
    openingAlt: "Un employé de DELUXE installe le mobilier de patio dans une cour propre, prête pour le printemps et l'été",
    closingAlt: "Un employé de DELUXE recouvre le mobilier extérieur dans une cour bien rangée, prête pour l'hiver",
    opening: {
      name: 'OUVERTURE DE TERRAIN',
      desc: "Après l'hiver, votre propriété a besoin d'une vraie remise en forme. DELUXE prépare votre terrain et vos espaces extérieurs pour la saison printemps-été.",
      includes: ["Enlèvement des débris, feuilles, branches et saletés accumulés durant l'hiver", 'Nettoyage général du terrain au printemps', 'Préparation des pelouses et des espaces extérieurs pour la nouvelle saison', 'Nettoyage et organisation des patios et espaces extérieurs', 'Remise en place du mobilier extérieur', 'Nettoyage et préparation générale de la propriété'],
    },
    closing: {
      name: 'FERMETURE DE TERRAIN',
      desc: "Avant l'arrivée du froid, DELUXE s'assure que votre propriété est propre, bien organisée et prête pour les mois d'hiver.",
      includes: ["Ramassage des feuilles et débris d'automne", 'Dernier nettoyage saisonnier du terrain', "Préparation des espaces extérieurs pour l'hiver", 'Rangement ou entreposage du mobilier extérieur', 'Nettoyage des patios et surfaces extérieures', 'Organisation du terrain avant les premières neiges', "Préparation générale pour l'hiver"],
    },
    ctaHeading: 'PRÉPAREZ VOTRE PROPRIÉTÉ POUR LA SAISON',
    cta: 'DEMANDER UNE SOUMISSION',
  },
  featured: {
    eyebrow: 'ENTRETIEN DE LA PELOUSE',
    line1: 'VOTRE COUR.',
    line2: 'SANS LES CORVÉES.',
    body: "Une propriété impeccable demande une attention constante. DELUXE s'occupe des travaux réguliers pour que vous puissiez consacrer votre temps à autre chose.",
    cta: 'OBTENIR UNE SOUMISSION',
    alt: 'Maison de banlieue avec une pelouse avant fraîchement tondue',
  },
  philosophy: {
    eyebrow: 'LA FAÇON DELUXE',
    line1: 'NOUS FAISONS',
    line2: 'LE TRAVAIL.',
    body: "DELUXE repose sur une idée simple : l'entretien d'une propriété ne devrait pas prendre tout votre temps libre.",
    points: [
      { n: '01', title: 'SE PRÉSENTER', text: "La fiabilité commence par faire ce que l'on a dit que l'on ferait." },
      { n: '02', title: 'FAIRE LE TRAVAIL', text: 'Nous offrons les services concrets dont les propriétaires ont réellement besoin.' },
      { n: '03', title: 'LAISSER MIEUX', text: 'Le souci des petits détails fait toute la différence.' },
    ],
  },
  how: {
    eyebrow: 'COMMENT ÇA FONCTIONNE',
    heading: 'COMMENCEZ SANS COMPLICATIONS.',
    steps: [
      { n: '01', title: 'DEMANDEZ', text: 'Dites-nous ce dont votre propriété a besoin.' },
      { n: '02', title: 'PLANIFIONS', text: 'Nous évaluons les travaux et déterminons le service approprié.' },
      { n: '03', title: 'DELUXE', text: 'Nous nous occupons du travail.' },
    ],
  },
  seasonal: {
    eyebrow: 'SERVICES SAISONNIERS',
    line1: 'UNE PROPRIÉTÉ.',
    line2: 'CHAQUE SAISON.',
    intro: "Les besoins de votre propriété changent au fil de l'année. DELUXE est conçue autour de l'entretien saisonnier, pour vous offrir un seul point de contact au gré des saisons.",
    cta: 'VOIR LES SERVICES SAISONNIERS',
    possible: 'Services possibles',
    seasons: [
      { id: 'spring', name: 'PRINTEMPS', text: 'Préparez votre propriété pour la saison.', items: ['Nettoyage de la cour', 'Entretien de la pelouse', 'Préparation extérieure de la propriété'], img: 'spring', alt: 'Plates-bandes qui reprennent vie au printemps' },
      { id: 'summer', name: 'ÉTÉ', text: 'Gardez votre propriété à son meilleur.', items: ['Entretien de la pelouse', 'Taille et finition', 'Entretien de la cour', 'Services extérieurs'], img: 'summer', alt: 'Pelouse verte ensoleillée en plein été' },
      { id: 'fall', name: 'AUTOMNE', text: "Réglez les accumulations de la saison avant l'hiver.", items: ['Ramassage des feuilles', 'Nettoyage de la cour', 'Nettoyage des gouttières', "Préparation pour l'hiver"], img: 'fall', alt: 'Feuilles d’automne recouvrant une cour résidentielle' },
      { id: 'winter', name: 'HIVER', text: 'Les services saisonniers continueront de s’étendre à mesure que DELUXE grandit.', items: [], img: 'winter', alt: 'Rue résidentielle québécoise sous la neige', note: "DELUXE est conçue pour devenir une entreprise d'entretien de propriétés à l'année. Les services d'hiver seront annoncés au fur et à mesure de leur ajout." },
    ],
  },
  recurring: {
    eyebrow: 'SERVICE RÉCURRENT',
    heading: 'UNE ALLURE DELUXE, TOUTE LA SAISON.',
    body: "Un entretien régulier empêche les travaux de s'accumuler et aide votre propriété à garder sa meilleure allure tout au long de la saison.",
    cta: "DEMANDEZ L'ENTRETIEN RÉCURRENT",
    alt: 'Extérieur de maison bien entretenu avec entrée propre et pelouse soignée',
  },
  aboutHome: {
    eyebrow: 'À PROPOS DE DELUXE',
    heading: 'CONÇUE POUR BIEN FAIRE LE TRAVAIL.',
    body: "DELUXE est une entreprise locale d'entretien de propriétés fondée sur une idée simple : vous ne devriez pas passer votre temps libre à vous soucier des travaux autour de votre maison.",
    cta: 'EN SAVOIR PLUS SUR DELUXE',
  },
  brand: {
    line1: 'BIEN PLUS QUE',
    line2: "DE L'ENTRETIEN.",
    line3: 'LE SOIN DES PROPRIÉTÉS.',
    sub: 'Une meilleure façon de prendre soin des travaux autour de votre maison.',
    alt: 'Propriété résidentielle haut de gamme photographiée au crépuscule',
  },
  faq: {
    eyebrow: 'FAQ',
    heading: 'DES QUESTIONS? DES RÉPONSES.',
    items: [
      { q: 'Quels services DELUXE offre-t-elle?', a: "DELUXE offre actuellement l'entretien de la pelouse, l'aménagement paysager et l'entretien de cour, le nettoyage de gouttières, le lavage de vitres, le nettoyage de bacs à ordures, l'entretien saisonnier, ainsi que l'ouverture et la fermeture de terrain pour les propriétés résidentielles." },
      { q: 'Offrez-vous un service récurrent?', a: 'Un service récurrent peut être discuté selon votre propriété et le service souhaité. Mentionnez-le dans votre demande de soumission et nous verrons les options ensemble.' },
      { q: 'Travaillez-vous avec les propriétaires?', a: 'Oui. DELUXE se concentre principalement sur les propriétés résidentielles et les propriétaires qui en prennent soin.' },
      { q: 'Comment demander une soumission?', a: 'Utilisez le formulaire de la page contact ou communiquez directement avec DELUXE. Dites-nous ce dont votre propriété a besoin et nous vous répondrons.' },
      { q: 'Êtes-vous actifs toute l’année?', a: "DELUXE est conçue autour des services saisonniers : l'offre varie donc au fil de l'année, au gré des saisons." },
      { q: 'Quels secteurs desservez-vous?', a: "DELUXE dessert actuellement les propriétaires de Montréal, Laval, de la Rive-Nord et des Laurentides. Envoyez une demande avec votre adresse et nous confirmerons la disponibilité pour votre propriété." },
    ],
  },
  finalCta: {
    line1: 'VOTRE PROPRIÉTÉ',
    line2: 'MÉRITE LE',
    line3: 'TRAITEMENT DELUXE.',
    sub: 'Laissez-nous nous occuper des travaux.',
    cta: 'OBTENIR UNE SOUMISSION GRATUITE',
  },
  area: {
    eyebrow: 'TERRITOIRE DE SERVICE',
    line1: 'UN SERVICE LOCAL.',
    line2: 'UNE APPROCHE HUMAINE.',
    body: "DELUXE dessert les propriétaires de Montréal, Laval, de la Rive-Nord et des Laurentides — et continue d'étendre son territoire de service à mesure que l'entreprise grandit.",
  },
  contactPage: {
    line1: 'PARLONS DE',
    line2: 'VOTRE PROPRIÉTÉ.',
    sub: 'Dites-nous ce dont vous avez besoin et nous vous répondrons au sujet de votre projet.',
    infoEyebrow: 'CONTACT',
    infoHeading: 'PRÊT À COMMENCER?',
    infoBody: 'Dites-nous ce dont votre propriété a besoin et laissez-nous rayer ces travaux de votre liste.',
    phone: 'Téléphone',
    phoneEnLabel: 'Ligne anglaise',
    phoneFrLabel: 'Ligne française',
    phoneEn: '438-377-0205',
    phoneFr: '438-459-3983',
    email: 'Courriel',
    emailValue: 'deluxeentretien@gmail.com',
    areaLabel: 'Territoire desservi',
    areaValue: 'Montréal • Laval • Rive-Nord • Laurentides',
    followUs: 'SUIVEZ-NOUS',
    note: 'Chaque demande est examinée personnellement. Plus vous donnez de détails, mieux nous pouvons préparer votre soumission.',
    alt: 'Extérieur de maison résidentielle chaleureuse en début de soirée',
  },
  form: {
    firstName: 'Prénom',
    lastName: 'Nom',
    phone: 'Téléphone',
    email: 'Courriel',
    address: 'Adresse de la propriété',
    service: 'Service',
    frequency: 'Fréquence',
    message: 'Message',
    messagePlaceholder: 'Parlez-nous un peu de vos besoins.',
    submit: 'DEMANDER UNE SOUMISSION GRATUITE',
    submitting: 'ENVOI…',
    required: 'requis',
    errors: {
      required: 'Ce champ est requis.',
      email: 'Entrez une adresse courriel valide.',
      phone: 'Entrez un numéro de téléphone valide.',
    },
    successTitle: 'MERCI.',
    successBody: 'Nous avons bien reçu votre demande. Nous vous contacterons bientôt.',
    errorGeneric: "Une erreur s'est produite lors de l'envoi. Veuillez réessayer.",
    again: 'ENVOYER UNE AUTRE DEMANDE',
    serviceOptions: [
      { value: 'lawn-care', label: 'Entretien de la pelouse' },
      { value: 'landscaping-yard-maintenance', label: 'Aménagement paysager et entretien de cour' },
      { value: 'gutter-cleaning', label: 'Nettoyage de gouttières' },
      { value: 'window-cleaning', label: 'Lavage de vitres' },
      { value: 'bin-cleaning', label: 'Nettoyage de bacs à ordures' },
      { value: 'seasonal-care', label: 'Entretien saisonnier de la propriété' },
      { value: 'yard-opening-closing', label: 'Ouverture / fermeture de terrain' },
      { value: 'multiple', label: 'Services multiples' },
      { value: 'other', label: 'Autre' },
    ],
    frequencyOptions: [
      { value: 'one-time', label: 'Unique' },
      { value: 'recurring', label: 'Récurrent' },
      { value: 'not-sure', label: 'Pas certain' },
    ],
  },
  aboutPage: {
    eyebrow: 'À PROPOS DE DELUXE',
    line1: 'CONÇUE POUR',
    line2: 'BIEN FAIRE LE TRAVAIL.',
    p1: "DELUXE est une entreprise locale d'entretien de propriétés fondée sur une idée simple : les propriétaires ne devraient pas avoir à passer leur temps libre à se soucier des travaux autour de leur propriété.",
    p2: "Nous commençons par les services extérieurs essentiels dont les propriétaires ont besoin, en vue de bâtir une entreprise d'entretien de propriétés haut de gamme qui pourra servir sa clientèle toute l'année.",
    whyEyebrow: 'POURQUOI DELUXE?',
    whyHeading: 'TROIS CHOSES QUI COMPTENT POUR NOUS.',
    principles: [
      { n: '01', title: 'SIMPLE', text: 'Aucune complexité inutile.' },
      { n: '02', title: 'PROFESSIONNEL', text: 'Une expérience claire et organisée, de la soumission aux travaux terminés.' },
      { n: '03', title: 'TRAVAILLANT', text: 'Nous savons qu’un bon entretien commence par la volonté de faire le travail.' },
    ],
    teamTitle: "L'ÉQUIPE DERRIÈRE DELUXE",
    teamBody: "Les informations sur le fondateur et l'équipe seront ajoutées ici à mesure que l'entreprise grandit.",
    alt: 'Maison québécoise moderne avec une façade paysagée et soignée',
  },
  footer: {
    tagline: "L'entretien professionnel de propriétés, signé Deluxe.",
    navigate: 'Navigation',
    services: 'Services',
    contact: 'Contact',
    socialSoon: 'Bientôt disponible',
    rights: '© 2026 DELUXE. Tous droits réservés.',
    privacy: 'Politique de confidentialité',
    terms: "Conditions d'utilisation",
    location: 'Montréal • Laval • Rive-Nord • Laurentides',
  },
  legal: {
    privacy: {
      title: 'POLITIQUE DE CONFIDENTIALITÉ',
      updated: 'Dernière mise à jour : 2026',
      sections: [
        { h: 'Aperçu', p: "DELUXE (« nous ») respecte votre vie privée. La présente politique explique quels renseignements nous recueillons sur ce site, pourquoi nous les recueillons et comment ils sont traités. Elle vise à respecter les lois applicables au Québec, notamment la Loi sur la protection des renseignements personnels dans le secteur privé." },
        { h: 'Renseignements recueillis', p: "Lorsque vous soumettez une demande de soumission, nous recueillons les renseignements que vous fournissez : votre nom, votre numéro de téléphone, votre adresse courriel, l'adresse de la propriété, le service et la fréquence choisis, ainsi que votre message. Nous ne recueillons aucune information de paiement sur ce site." },
        { h: 'Utilisation', p: "Nous utilisons ces renseignements uniquement pour répondre à votre demande, préparer une soumission, planifier et effectuer les travaux, et communiquer avec vous au sujet de votre propriété. Nous ne vendons pas vos renseignements personnels." },
        { h: 'Conservation et sécurité', p: "Les demandes de soumission sont conservées de façon sécuritaire, seulement le temps nécessaire pour traiter votre demande et gérer notre relation d'affaires. L'accès est limité aux personnes qui en ont besoin pour vous répondre." },
        { h: 'Vos droits', p: "En vertu des lois du Québec, vous pouvez demander l'accès aux renseignements personnels que nous détenons à votre sujet, en demander la correction ou la suppression. Pour toute demande, écrivez-nous à deluxeentretien@gmail.com." },
        { h: 'Modifications', p: "Cette politique peut être mise à jour à mesure que l'entreprise grandit. La version à jour sera toujours disponible sur cette page." },
      ],
    },
    terms: {
      title: "CONDITIONS D'UTILISATION",
      updated: 'Dernière mise à jour : 2026',
      sections: [
        { h: 'Les services', p: "DELUXE offre des services résidentiels d'entretien de propriétés : entretien de la pelouse, aménagement paysager et entretien de cour, nettoyage de gouttières, lavage de vitres, nettoyage de bacs à ordures et entretien saisonnier. La disponibilité des services peut varier selon la saison et le secteur." },
        { h: 'Soumissions', p: "L'envoi d'une demande de soumission ne crée pas de contrat. Les soumissions sont préparées à partir des renseignements fournis et confirmées avec vous avant le début des travaux. La portée exacte de chaque travail est convenue à l'avance." },
        { h: 'Planification', p: "Les dates de service sont confirmées directement avec vous. La météo et les conditions saisonnières au Québec peuvent affecter l'horaire des travaux extérieurs; nous vous informerons de tout changement le plus tôt possible." },
        { h: 'Votre propriété', p: "Vous êtes responsable de fournir des renseignements exacts sur votre propriété et d'assurer un accès raisonnable aux zones où les travaux doivent être effectués." },
        { h: 'Contenu du site', p: "Le contenu de ce site est fourni à titre informatif et peut être modifié en tout temps sans préavis. Rien sur ce site ne constitue une offre contraignante tant qu'elle n'a pas été confirmée directement par DELUXE." },
        { h: 'Lois applicables', p: 'Ces conditions sont régies par les lois applicables dans la province de Québec, Canada.' },
      ],
    },
  },
  admin: {
    title: 'DEMANDES DE SOUMISSION',
    loginHeading: 'ACCÈS ADMIN',
    loginSub: 'Espace privé de DELUXE ENTERPRISE.',
    email: 'Courriel',
    password: 'Mot de passe',
    signIn: 'SE CONNECTER',
    signingIn: 'CONNEXION…',
    wrong: 'Courriel ou mot de passe incorrect.',
    locked: 'Trop de tentatives. Veuillez réessayer plus tard.',
    logout: 'DÉCONNEXION',
    total: 'Total',
    newLabel: 'Nouvelles',
    contacted: 'Contactées',
    completed: 'Complétées',
    empty: 'Aucune demande pour le moment.',
    emptySub: 'Les nouvelles demandes du site apparaîtront ici.',
    markContacted: 'MARQUER CONTACTÉE',
    markCompleted: 'MARQUER COMPLÉTÉE',
    delete: 'Supprimer',
    confirmDelete: 'Supprimer cette demande? Cette action est irréversible.',
    backToSite: '← Retour au site',
    received: 'Reçue le',
    loadError: 'Impossible de charger les demandes. Veuillez vous reconnecter.',
  },
  seo: {
    home: { title: 'DELUXE | Aménagement paysager et entretien de propriétés au Québec', desc: "DELUXE offre des services professionnels d'aménagement paysager, d'entretien de pelouse et d'entretien saisonnier à Montréal, Laval, sur la Rive-Nord et dans les Laurentides. Demandez une soumission." },
    services: { title: 'Services | DELUXE ENTERPRISE Entretien de propriétés', desc: "Entretien de pelouse, aménagement paysager, nettoyage de gouttières, lavage de vitres, nettoyage de bacs et entretien saisonnier à Montréal, Laval, sur la Rive-Nord et dans les Laurentides." },
    about: { title: 'À propos | DELUXE ENTERPRISE Entretien de propriétés', desc: "DELUXE est une entreprise québécoise locale d'entretien de propriétés : simple, professionnelle et travaillante." },
    seasonal: { title: 'Services saisonniers | DELUXE ENTERPRISE Entretien de propriétés', desc: "Une propriété, chaque saison. Entretien de printemps, d'été, d'automne et d'hiver à Montréal, Laval, sur la Rive-Nord et dans les Laurentides." },
    contact: { title: 'Soumission gratuite | DELUXE ENTERPRISE Entretien de propriétés', desc: 'Dites-nous ce dont votre propriété a besoin et nous vous répondrons. Demandez une soumission gratuite à DELUXE.' },
    privacy: { title: 'Politique de confidentialité | DELUXE ENTERPRISE', desc: 'Comment DELUXE recueille, utilise et protège vos renseignements personnels.' },
    terms: { title: "Conditions d'utilisation | DELUXE ENTERPRISE", desc: "Les conditions qui régissent l'utilisation du site et des services de DELUXE." },
  },
};
